import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <a name="transformstream" id="transformstream"></a>
    <h1 {...{
      "id": "windowtransformstream"
    }}>{`window.TransformStream`}</h1>
    <p><strong parentName="p">{`See`}</strong>{`: `}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/en-US/docs/Web/API/TransformStream"
      }}>{`Web APIs - TransformStream`}</a>{`  `}</p>
    <a name="new-transformstream-new" id="new-transformstream-new"></a>
    <h2 {...{
      "id": "transformstreamtransformer-writablestrategy-readablestrategy"
    }}>{`TransformStream(transformer, writableStrategy, readableStrategy)`}</h2>
    <p>{`Cretes a new TransformStream object wrapping the provided transformer.
If no transformer argument is supplied, then the result will be an identity transform stream.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Param`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Description`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`transformer`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Defines algorithms for the specific transformation to be performed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`transformer.start`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Called when the TransfromStream is constructed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`transformer.transform`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Called when a chunk written to the writable is ready to be transformed.          If no transform method is supplied, the identity transform is used.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`transformer.flush`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Called after all chunks written to the writable have been successfully transformed,          and the writable is about to be closed.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`writableStrategy`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Queuing strategy for the stream.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`writableStrategy.highWaterMark`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A non-negative number.          The total number of chunks that can be contained in the internal queue before backpressure is applied`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`writableStrategy.size`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The size to use for each chunk, in bytes.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`readableStrategy`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`Object`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Queuing strategy for the stream.`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`readableStrategy.highWaterMark`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`number`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`A non-negative number.          The total number of chunks that can be contained in the internal queue before backpressure is applied`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`readableStrategy.size`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`function`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`The size to use for each chunk, in bytes.`}</td>
        </tr>
      </tbody>
    </table>
    <a name="transformstream-readable" id="transformstream-readable"></a>
    <h2 {...{
      "id": "readable--readablestream"
    }}>{`readable : `}<inlineCode parentName="h2">{`ReadableStream`}</inlineCode></h2>
    <p>{`ReadableStream representing the readable of this TransformStream.`}</p>
    <a name="transformstream-writable" id="transformstream-writable"></a>
    <h2 {...{
      "id": "writable--writablestream"
    }}>{`writable : `}<inlineCode parentName="h2">{`WritableStream`}</inlineCode></h2>
    <p>{`WritableStream representing the writable of this TransformStream.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      